var up_light_animationData = {
    "v": "5.7.13",
    "fr": 25,
    "ip": 0,
    "op": 35,
    "w": 72,
    "h": 72,
    "nm": "赞浅色",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "形状图层 2",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 0,
                            "s": [
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 5,
                            "s": [
                                100
                            ]
                        },
                        {
                            "t": 10,
                            "s": [
                                1
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        40.996,
                        37.604,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        4.996,
                        2.354,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            2.426,
                                            -1.011
                                        ],
                                        [
                                            5.5,
                                            -6.688
                                        ],
                                        [
                                            0.25,
                                            -7.75
                                        ],
                                        [
                                            -6.75,
                                            -1.625
                                        ],
                                        [
                                            -4.5,
                                            0
                                        ],
                                        [
                                            0.438,
                                            1.5
                                        ],
                                        [
                                            1,
                                            0.375
                                        ],
                                        [
                                            2.125,
                                            1.938
                                        ],
                                        [
                                            4,
                                            0
                                        ],
                                        [
                                            0.375,
                                            0.25
                                        ],
                                        [
                                            -0.75,
                                            4.5
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -3,
                                            1.25
                                        ],
                                        [
                                            -2.668,
                                            3.244
                                        ],
                                        [
                                            -0.25,
                                            7.75
                                        ],
                                        [
                                            6.75,
                                            1.625
                                        ],
                                        [
                                            4.5,
                                            0
                                        ],
                                        [
                                            2,
                                            -0.375
                                        ],
                                        [
                                            1.438,
                                            -0.125
                                        ],
                                        [
                                            3.875,
                                            -1.688
                                        ],
                                        [
                                            -4,
                                            0
                                        ],
                                        [
                                            -0.875,
                                            -1.5
                                        ],
                                        [
                                            0.75,
                                            -4.5
                                        ]
                                    ],
                                    "v": [
                                        [
                                            4,
                                            -18.125
                                        ],
                                        [
                                            -2.875,
                                            -4.25
                                        ],
                                        [
                                            -11.625,
                                            10
                                        ],
                                        [
                                            -1.25,
                                            22.125
                                        ],
                                        [
                                            13.5,
                                            22.75
                                        ],
                                        [
                                            17.75,
                                            17.625
                                        ],
                                        [
                                            18.75,
                                            12.25
                                        ],
                                        [
                                            19.625,
                                            6.375
                                        ],
                                        [
                                            17.75,
                                            -1.625
                                        ],
                                        [
                                            6.875,
                                            -1.875
                                        ],
                                        [
                                            10,
                                            -12.125
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "路径 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 70,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 3.9,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "bm": 0,
                            "nm": "描边 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    3.375,
                                                    0.25
                                                ],
                                                [
                                                    1.562,
                                                    -3.875
                                                ],
                                                [
                                                    -4.5,
                                                    -1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -3.375,
                                                    -0.25
                                                ],
                                                [
                                                    -2.161,
                                                    5.36
                                                ],
                                                [
                                                    4.5,
                                                    1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.438,
                                                    2.312
                                                ],
                                                [
                                                    -20.125,
                                                    5.5
                                                ],
                                                [
                                                    -16.875,
                                                    20
                                                ],
                                                [
                                                    -10.438,
                                                    20.25
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "路径 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 70,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 3.9,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "描边 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "变换"
                                }
                            ],
                            "nm": "形状 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "变换"
                        }
                    ],
                    "nm": "形状 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 750,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "形状图层 1",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 5,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 10,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 10,
                            "s": [
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 18,
                            "s": [
                                -12
                            ]
                        },
                        {
                            "t": 23,
                            "s": [
                                0
                            ]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        40.996,
                        37.354,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        4.996,
                        2.354,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0.167,
                                    0.167,
                                    0.271
                                ]
                            },
                            "t": 10,
                            "s": [
                                109,
                                109,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 18,
                            "s": [
                                140,
                                140,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 23,
                            "s": [
                                98.5,
                                98.5,
                                100
                            ]
                        },
                        {
                            "t": 30,
                            "s": [
                                109,
                                109,
                                100
                            ]
                        }
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            2.426,
                                            -1.011
                                        ],
                                        [
                                            5.5,
                                            -6.688
                                        ],
                                        [
                                            0.25,
                                            -7.75
                                        ],
                                        [
                                            -6.75,
                                            -1.625
                                        ],
                                        [
                                            -4.5,
                                            0
                                        ],
                                        [
                                            0.438,
                                            1.5
                                        ],
                                        [
                                            1,
                                            0.375
                                        ],
                                        [
                                            2.125,
                                            1.938
                                        ],
                                        [
                                            4,
                                            0
                                        ],
                                        [
                                            0.375,
                                            0.25
                                        ],
                                        [
                                            -0.75,
                                            4.5
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -3,
                                            1.25
                                        ],
                                        [
                                            -2.668,
                                            3.244
                                        ],
                                        [
                                            -0.25,
                                            7.75
                                        ],
                                        [
                                            6.75,
                                            1.625
                                        ],
                                        [
                                            4.5,
                                            0
                                        ],
                                        [
                                            2,
                                            -0.375
                                        ],
                                        [
                                            1.438,
                                            -0.125
                                        ],
                                        [
                                            3.875,
                                            -1.688
                                        ],
                                        [
                                            -4,
                                            0
                                        ],
                                        [
                                            -0.875,
                                            -1.5
                                        ],
                                        [
                                            0.75,
                                            -4.5
                                        ]
                                    ],
                                    "v": [
                                        [
                                            4,
                                            -18.125
                                        ],
                                        [
                                            -2.875,
                                            -4.25
                                        ],
                                        [
                                            -11.625,
                                            10
                                        ],
                                        [
                                            -1.25,
                                            22.125
                                        ],
                                        [
                                            13.5,
                                            22.75
                                        ],
                                        [
                                            17.75,
                                            17.625
                                        ],
                                        [
                                            18.75,
                                            12.25
                                        ],
                                        [
                                            19.625,
                                            6.375
                                        ],
                                        [
                                            17.75,
                                            -1.625
                                        ],
                                        [
                                            6.875,
                                            -1.875
                                        ],
                                        [
                                            10,
                                            -12.125
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "路径 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 70,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "填充 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -1.223,
                                                    1.609
                                                ],
                                                [
                                                    1.562,
                                                    -3.875
                                                ],
                                                [
                                                    -4.5,
                                                    -1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.204,
                                                    1.892
                                                ],
                                                [
                                                    -0.344,
                                                    1.778
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -3.373,
                                                    -0.274
                                                ],
                                                [
                                                    -2.161,
                                                    5.36
                                                ],
                                                [
                                                    4.5,
                                                    1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.204,
                                                    -1.892
                                                ],
                                                [
                                                    0.344,
                                                    -1.778
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.438,
                                                    2.312
                                                ],
                                                [
                                                    -20.125,
                                                    5.5
                                                ],
                                                [
                                                    -16.875,
                                                    20
                                                ],
                                                [
                                                    -10.438,
                                                    20.25
                                                ],
                                                [
                                                    -12.604,
                                                    17.167
                                                ],
                                                [
                                                    -13.578,
                                                    7.247
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "路径 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0,
                                            1
                                        ],
                                        "ix": 4
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 70,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "填充 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "变换"
                                }
                            ],
                            "nm": "形状 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "变换"
                        }
                    ],
                    "nm": "形状 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 750,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}

var up_dark_animationData = {
    "v": "5.7.13",
    "fr": 25,
    "ip": 0,
    "op": 35,
    "w": 72,
    "h": 72,
    "nm": "赞暗色",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "形状图层 2",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 0,
                            "s": [
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 5,
                            "s": [
                                100
                            ]
                        },
                        {
                            "t": 10,
                            "s": [
                                1
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        40.996,
                        37.604,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        4.996,
                        2.354,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            2.426,
                                            -1.011
                                        ],
                                        [
                                            5.5,
                                            -6.688
                                        ],
                                        [
                                            0.25,
                                            -7.75
                                        ],
                                        [
                                            -6.75,
                                            -1.625
                                        ],
                                        [
                                            -4.5,
                                            0
                                        ],
                                        [
                                            0.438,
                                            1.5
                                        ],
                                        [
                                            1,
                                            0.375
                                        ],
                                        [
                                            2.125,
                                            1.938
                                        ],
                                        [
                                            4,
                                            0
                                        ],
                                        [
                                            0.375,
                                            0.25
                                        ],
                                        [
                                            -0.75,
                                            4.5
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -3,
                                            1.25
                                        ],
                                        [
                                            -2.668,
                                            3.244
                                        ],
                                        [
                                            -0.25,
                                            7.75
                                        ],
                                        [
                                            6.75,
                                            1.625
                                        ],
                                        [
                                            4.5,
                                            0
                                        ],
                                        [
                                            2,
                                            -0.375
                                        ],
                                        [
                                            1.438,
                                            -0.125
                                        ],
                                        [
                                            3.875,
                                            -1.688
                                        ],
                                        [
                                            -4,
                                            0
                                        ],
                                        [
                                            -0.875,
                                            -1.5
                                        ],
                                        [
                                            0.75,
                                            -4.5
                                        ]
                                    ],
                                    "v": [
                                        [
                                            4,
                                            -18.125
                                        ],
                                        [
                                            -2.875,
                                            -4.25
                                        ],
                                        [
                                            -11.625,
                                            10
                                        ],
                                        [
                                            -1.25,
                                            22.125
                                        ],
                                        [
                                            13.5,
                                            22.75
                                        ],
                                        [
                                            17.75,
                                            17.625
                                        ],
                                        [
                                            18.75,
                                            12.25
                                        ],
                                        [
                                            19.625,
                                            6.375
                                        ],
                                        [
                                            17.75,
                                            -1.625
                                        ],
                                        [
                                            6.875,
                                            -1.875
                                        ],
                                        [
                                            10,
                                            -12.125
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "路径 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 70,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 3.9,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "bm": 0,
                            "nm": "描边 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    3.375,
                                                    0.25
                                                ],
                                                [
                                                    1.562,
                                                    -3.875
                                                ],
                                                [
                                                    -4.5,
                                                    -1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -3.375,
                                                    -0.25
                                                ],
                                                [
                                                    -2.161,
                                                    5.36
                                                ],
                                                [
                                                    4.5,
                                                    1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.438,
                                                    2.312
                                                ],
                                                [
                                                    -20.125,
                                                    5.5
                                                ],
                                                [
                                                    -16.875,
                                                    20
                                                ],
                                                [
                                                    -10.438,
                                                    20.25
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "路径 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 70,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 3.9,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "描边 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "变换"
                                }
                            ],
                            "nm": "形状 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "变换"
                        }
                    ],
                    "nm": "形状 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 750,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "形状图层 1",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 5,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 10,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 10,
                            "s": [
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 18,
                            "s": [
                                -12
                            ]
                        },
                        {
                            "t": 23,
                            "s": [
                                0
                            ]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        40.996,
                        37.354,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        4.996,
                        2.354,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0.167,
                                    0.167,
                                    0.271
                                ]
                            },
                            "t": 10,
                            "s": [
                                109,
                                109,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 18,
                            "s": [
                                140,
                                140,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 23,
                            "s": [
                                98.5,
                                98.5,
                                100
                            ]
                        },
                        {
                            "t": 30,
                            "s": [
                                109,
                                109,
                                100
                            ]
                        }
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            2.426,
                                            -1.011
                                        ],
                                        [
                                            5.5,
                                            -6.688
                                        ],
                                        [
                                            0.25,
                                            -7.75
                                        ],
                                        [
                                            -6.75,
                                            -1.625
                                        ],
                                        [
                                            -4.5,
                                            0
                                        ],
                                        [
                                            0.438,
                                            1.5
                                        ],
                                        [
                                            1,
                                            0.375
                                        ],
                                        [
                                            2.125,
                                            1.938
                                        ],
                                        [
                                            4,
                                            0
                                        ],
                                        [
                                            0.375,
                                            0.25
                                        ],
                                        [
                                            -0.75,
                                            4.5
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -3,
                                            1.25
                                        ],
                                        [
                                            -2.668,
                                            3.244
                                        ],
                                        [
                                            -0.25,
                                            7.75
                                        ],
                                        [
                                            6.75,
                                            1.625
                                        ],
                                        [
                                            4.5,
                                            0
                                        ],
                                        [
                                            2,
                                            -0.375
                                        ],
                                        [
                                            1.438,
                                            -0.125
                                        ],
                                        [
                                            3.875,
                                            -1.688
                                        ],
                                        [
                                            -4,
                                            0
                                        ],
                                        [
                                            -0.875,
                                            -1.5
                                        ],
                                        [
                                            0.75,
                                            -4.5
                                        ]
                                    ],
                                    "v": [
                                        [
                                            4,
                                            -18.125
                                        ],
                                        [
                                            -2.875,
                                            -4.25
                                        ],
                                        [
                                            -11.625,
                                            10
                                        ],
                                        [
                                            -1.25,
                                            22.125
                                        ],
                                        [
                                            13.5,
                                            22.75
                                        ],
                                        [
                                            17.75,
                                            17.625
                                        ],
                                        [
                                            18.75,
                                            12.25
                                        ],
                                        [
                                            19.625,
                                            6.375
                                        ],
                                        [
                                            17.75,
                                            -1.625
                                        ],
                                        [
                                            6.875,
                                            -1.875
                                        ],
                                        [
                                            10,
                                            -12.125
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "路径 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 70,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "填充 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -1.223,
                                                    1.609
                                                ],
                                                [
                                                    1.562,
                                                    -3.875
                                                ],
                                                [
                                                    -4.5,
                                                    -1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.204,
                                                    1.892
                                                ],
                                                [
                                                    -0.344,
                                                    1.778
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -3.373,
                                                    -0.274
                                                ],
                                                [
                                                    -2.161,
                                                    5.36
                                                ],
                                                [
                                                    4.5,
                                                    1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.204,
                                                    -1.892
                                                ],
                                                [
                                                    0.344,
                                                    -1.778
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.438,
                                                    2.312
                                                ],
                                                [
                                                    -20.125,
                                                    5.5
                                                ],
                                                [
                                                    -16.875,
                                                    20
                                                ],
                                                [
                                                    -10.438,
                                                    20.25
                                                ],
                                                [
                                                    -12.604,
                                                    17.167
                                                ],
                                                [
                                                    -13.578,
                                                    7.247
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "路径 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 4
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 70,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "填充 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "变换"
                                }
                            ],
                            "nm": "形状 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "变换"
                        }
                    ],
                    "nm": "形状 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 750,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}

var down_dark_animationData = {
    "v": "5.7.13",
    "fr": 25,
    "ip": 0,
    "op": 35,
    "w": 72,
    "h": 72,
    "nm": "踩暗色",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "形状图层 2",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 0,
                            "s": [
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 5,
                            "s": [
                                100
                            ]
                        },
                        {
                            "t": 10,
                            "s": [
                                1
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        40.996,
                        37.604,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        4.996,
                        2.354,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        -100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            2.426,
                                            -1.011
                                        ],
                                        [
                                            5.5,
                                            -6.688
                                        ],
                                        [
                                            0.25,
                                            -7.75
                                        ],
                                        [
                                            -6.75,
                                            -1.625
                                        ],
                                        [
                                            -4.5,
                                            0
                                        ],
                                        [
                                            0.438,
                                            1.5
                                        ],
                                        [
                                            1,
                                            0.375
                                        ],
                                        [
                                            2.125,
                                            1.938
                                        ],
                                        [
                                            4,
                                            0
                                        ],
                                        [
                                            0.375,
                                            0.25
                                        ],
                                        [
                                            -0.75,
                                            4.5
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -3,
                                            1.25
                                        ],
                                        [
                                            -2.668,
                                            3.244
                                        ],
                                        [
                                            -0.25,
                                            7.75
                                        ],
                                        [
                                            6.75,
                                            1.625
                                        ],
                                        [
                                            4.5,
                                            0
                                        ],
                                        [
                                            2,
                                            -0.375
                                        ],
                                        [
                                            1.438,
                                            -0.125
                                        ],
                                        [
                                            3.875,
                                            -1.688
                                        ],
                                        [
                                            -4,
                                            0
                                        ],
                                        [
                                            -0.875,
                                            -1.5
                                        ],
                                        [
                                            0.75,
                                            -4.5
                                        ]
                                    ],
                                    "v": [
                                        [
                                            4,
                                            -18.125
                                        ],
                                        [
                                            -2.875,
                                            -4.25
                                        ],
                                        [
                                            -11.625,
                                            10
                                        ],
                                        [
                                            -1.25,
                                            22.125
                                        ],
                                        [
                                            13.5,
                                            22.75
                                        ],
                                        [
                                            17.75,
                                            17.625
                                        ],
                                        [
                                            18.75,
                                            12.25
                                        ],
                                        [
                                            19.625,
                                            6.375
                                        ],
                                        [
                                            17.75,
                                            -1.625
                                        ],
                                        [
                                            6.875,
                                            -1.875
                                        ],
                                        [
                                            10,
                                            -12.125
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "路径 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 70,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 3.9,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "bm": 0,
                            "nm": "描边 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    3.375,
                                                    0.25
                                                ],
                                                [
                                                    1.562,
                                                    -3.875
                                                ],
                                                [
                                                    -4.5,
                                                    -1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -3.375,
                                                    -0.25
                                                ],
                                                [
                                                    -2.161,
                                                    5.36
                                                ],
                                                [
                                                    4.5,
                                                    1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.438,
                                                    2.312
                                                ],
                                                [
                                                    -20.125,
                                                    5.5
                                                ],
                                                [
                                                    -16.875,
                                                    20
                                                ],
                                                [
                                                    -10.438,
                                                    20.25
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "路径 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 70,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 3.9,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "描边 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "变换"
                                }
                            ],
                            "nm": "形状 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "变换"
                        }
                    ],
                    "nm": "形状 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 750,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "形状图层 1",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 5,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 10,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 10,
                            "s": [
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 18,
                            "s": [
                                -12
                            ]
                        },
                        {
                            "t": 23,
                            "s": [
                                0
                            ]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        40.996,
                        37.354,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        4.996,
                        2.354,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0.167,
                                    0.167,
                                    0
                                ]
                            },
                            "t": 10,
                            "s": [
                                109,
                                -109,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 18,
                            "s": [
                                140,
                                -140,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 23,
                            "s": [
                                98.5,
                                -98.5,
                                100
                            ]
                        },
                        {
                            "t": 30,
                            "s": [
                                109,
                                -109,
                                100
                            ]
                        }
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            2.426,
                                            -1.011
                                        ],
                                        [
                                            5.5,
                                            -6.688
                                        ],
                                        [
                                            0.25,
                                            -7.75
                                        ],
                                        [
                                            -6.75,
                                            -1.625
                                        ],
                                        [
                                            -4.5,
                                            0
                                        ],
                                        [
                                            0.438,
                                            1.5
                                        ],
                                        [
                                            1,
                                            0.375
                                        ],
                                        [
                                            2.125,
                                            1.938
                                        ],
                                        [
                                            4,
                                            0
                                        ],
                                        [
                                            0.375,
                                            0.25
                                        ],
                                        [
                                            -0.75,
                                            4.5
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -3,
                                            1.25
                                        ],
                                        [
                                            -2.668,
                                            3.244
                                        ],
                                        [
                                            -0.25,
                                            7.75
                                        ],
                                        [
                                            6.75,
                                            1.625
                                        ],
                                        [
                                            4.5,
                                            0
                                        ],
                                        [
                                            2,
                                            -0.375
                                        ],
                                        [
                                            1.438,
                                            -0.125
                                        ],
                                        [
                                            3.875,
                                            -1.688
                                        ],
                                        [
                                            -4,
                                            0
                                        ],
                                        [
                                            -0.875,
                                            -1.5
                                        ],
                                        [
                                            0.75,
                                            -4.5
                                        ]
                                    ],
                                    "v": [
                                        [
                                            4,
                                            -18.125
                                        ],
                                        [
                                            -2.875,
                                            -4.25
                                        ],
                                        [
                                            -11.625,
                                            10
                                        ],
                                        [
                                            -1.25,
                                            22.125
                                        ],
                                        [
                                            13.5,
                                            22.75
                                        ],
                                        [
                                            17.75,
                                            17.625
                                        ],
                                        [
                                            18.75,
                                            12.25
                                        ],
                                        [
                                            19.625,
                                            6.375
                                        ],
                                        [
                                            17.75,
                                            -1.625
                                        ],
                                        [
                                            6.875,
                                            -1.875
                                        ],
                                        [
                                            10,
                                            -12.125
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "路径 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 70,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "填充 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -1.223,
                                                    1.609
                                                ],
                                                [
                                                    1.562,
                                                    -3.875
                                                ],
                                                [
                                                    -4.5,
                                                    -1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.204,
                                                    1.892
                                                ],
                                                [
                                                    -0.344,
                                                    1.778
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -3.373,
                                                    -0.274
                                                ],
                                                [
                                                    -2.161,
                                                    5.36
                                                ],
                                                [
                                                    4.5,
                                                    1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.204,
                                                    -1.892
                                                ],
                                                [
                                                    0.344,
                                                    -1.778
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.438,
                                                    2.312
                                                ],
                                                [
                                                    -20.125,
                                                    5.5
                                                ],
                                                [
                                                    -16.875,
                                                    20
                                                ],
                                                [
                                                    -10.438,
                                                    20.25
                                                ],
                                                [
                                                    -12.604,
                                                    17.167
                                                ],
                                                [
                                                    -13.578,
                                                    7.247
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "路径 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 4
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 70,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "填充 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "变换"
                                }
                            ],
                            "nm": "形状 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "变换"
                        }
                    ],
                    "nm": "形状 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 750,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}

var down_light_animationData = {
    "v": "5.7.13",
    "fr": 25,
    "ip": 0,
    "op": 35,
    "w": 72,
    "h": 72,
    "nm": "踩浅色",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "形状图层 2",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 0,
                            "s": [
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 5,
                            "s": [
                                100
                            ]
                        },
                        {
                            "t": 10,
                            "s": [
                                1
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        40.996,
                        37.604,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        4.996,
                        2.354,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        -100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            2.426,
                                            -1.011
                                        ],
                                        [
                                            5.5,
                                            -6.688
                                        ],
                                        [
                                            0.25,
                                            -7.75
                                        ],
                                        [
                                            -6.75,
                                            -1.625
                                        ],
                                        [
                                            -4.5,
                                            0
                                        ],
                                        [
                                            0.438,
                                            1.5
                                        ],
                                        [
                                            1,
                                            0.375
                                        ],
                                        [
                                            2.125,
                                            1.938
                                        ],
                                        [
                                            4,
                                            0
                                        ],
                                        [
                                            0.375,
                                            0.25
                                        ],
                                        [
                                            -0.75,
                                            4.5
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -3,
                                            1.25
                                        ],
                                        [
                                            -2.668,
                                            3.244
                                        ],
                                        [
                                            -0.25,
                                            7.75
                                        ],
                                        [
                                            6.75,
                                            1.625
                                        ],
                                        [
                                            4.5,
                                            0
                                        ],
                                        [
                                            2,
                                            -0.375
                                        ],
                                        [
                                            1.438,
                                            -0.125
                                        ],
                                        [
                                            3.875,
                                            -1.688
                                        ],
                                        [
                                            -4,
                                            0
                                        ],
                                        [
                                            -0.875,
                                            -1.5
                                        ],
                                        [
                                            0.75,
                                            -4.5
                                        ]
                                    ],
                                    "v": [
                                        [
                                            4,
                                            -18.125
                                        ],
                                        [
                                            -2.875,
                                            -4.25
                                        ],
                                        [
                                            -11.625,
                                            10
                                        ],
                                        [
                                            -1.25,
                                            22.125
                                        ],
                                        [
                                            13.5,
                                            22.75
                                        ],
                                        [
                                            17.75,
                                            17.625
                                        ],
                                        [
                                            18.75,
                                            12.25
                                        ],
                                        [
                                            19.625,
                                            6.375
                                        ],
                                        [
                                            17.75,
                                            -1.625
                                        ],
                                        [
                                            6.875,
                                            -1.875
                                        ],
                                        [
                                            10,
                                            -12.125
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "路径 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 70,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 3.9,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "bm": 0,
                            "nm": "描边 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    3.375,
                                                    0.25
                                                ],
                                                [
                                                    1.562,
                                                    -3.875
                                                ],
                                                [
                                                    -4.5,
                                                    -1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -3.375,
                                                    -0.25
                                                ],
                                                [
                                                    -2.161,
                                                    5.36
                                                ],
                                                [
                                                    4.5,
                                                    1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.438,
                                                    2.312
                                                ],
                                                [
                                                    -20.125,
                                                    5.5
                                                ],
                                                [
                                                    -16.875,
                                                    20
                                                ],
                                                [
                                                    -10.438,
                                                    20.25
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "路径 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 70,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 3.9,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "描边 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "变换"
                                }
                            ],
                            "nm": "形状 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "变换"
                        }
                    ],
                    "nm": "形状 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 750,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "形状图层 1",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 5,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 10,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 10,
                            "s": [
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 18,
                            "s": [
                                -12
                            ]
                        },
                        {
                            "t": 23,
                            "s": [
                                0
                            ]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        40.996,
                        37.354,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        4.996,
                        2.354,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0.167,
                                    0.167,
                                    0
                                ]
                            },
                            "t": 10,
                            "s": [
                                109,
                                -109,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 18,
                            "s": [
                                140,
                                -140,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 23,
                            "s": [
                                98.5,
                                -98.5,
                                100
                            ]
                        },
                        {
                            "t": 30,
                            "s": [
                                109,
                                -109,
                                100
                            ]
                        }
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            2.426,
                                            -1.011
                                        ],
                                        [
                                            5.5,
                                            -6.688
                                        ],
                                        [
                                            0.25,
                                            -7.75
                                        ],
                                        [
                                            -6.75,
                                            -1.625
                                        ],
                                        [
                                            -4.5,
                                            0
                                        ],
                                        [
                                            0.438,
                                            1.5
                                        ],
                                        [
                                            1,
                                            0.375
                                        ],
                                        [
                                            2.125,
                                            1.938
                                        ],
                                        [
                                            4,
                                            0
                                        ],
                                        [
                                            0.375,
                                            0.25
                                        ],
                                        [
                                            -0.75,
                                            4.5
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -3,
                                            1.25
                                        ],
                                        [
                                            -2.668,
                                            3.244
                                        ],
                                        [
                                            -0.25,
                                            7.75
                                        ],
                                        [
                                            6.75,
                                            1.625
                                        ],
                                        [
                                            4.5,
                                            0
                                        ],
                                        [
                                            2,
                                            -0.375
                                        ],
                                        [
                                            1.438,
                                            -0.125
                                        ],
                                        [
                                            3.875,
                                            -1.688
                                        ],
                                        [
                                            -4,
                                            0
                                        ],
                                        [
                                            -0.875,
                                            -1.5
                                        ],
                                        [
                                            0.75,
                                            -4.5
                                        ]
                                    ],
                                    "v": [
                                        [
                                            4,
                                            -18.125
                                        ],
                                        [
                                            -2.875,
                                            -4.25
                                        ],
                                        [
                                            -11.625,
                                            10
                                        ],
                                        [
                                            -1.25,
                                            22.125
                                        ],
                                        [
                                            13.5,
                                            22.75
                                        ],
                                        [
                                            17.75,
                                            17.625
                                        ],
                                        [
                                            18.75,
                                            12.25
                                        ],
                                        [
                                            19.625,
                                            6.375
                                        ],
                                        [
                                            17.75,
                                            -1.625
                                        ],
                                        [
                                            6.875,
                                            -1.875
                                        ],
                                        [
                                            10,
                                            -12.125
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "路径 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 70,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "填充 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -1.223,
                                                    1.609
                                                ],
                                                [
                                                    1.562,
                                                    -3.875
                                                ],
                                                [
                                                    -4.5,
                                                    -1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.204,
                                                    1.892
                                                ],
                                                [
                                                    -0.344,
                                                    1.778
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -3.373,
                                                    -0.274
                                                ],
                                                [
                                                    -2.161,
                                                    5.36
                                                ],
                                                [
                                                    4.5,
                                                    1.875
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.204,
                                                    -1.892
                                                ],
                                                [
                                                    0.344,
                                                    -1.778
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.438,
                                                    2.312
                                                ],
                                                [
                                                    -20.125,
                                                    5.5
                                                ],
                                                [
                                                    -16.875,
                                                    20
                                                ],
                                                [
                                                    -10.438,
                                                    20.25
                                                ],
                                                [
                                                    -12.604,
                                                    17.167
                                                ],
                                                [
                                                    -13.578,
                                                    7.247
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "路径 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0,
                                            1
                                        ],
                                        "ix": 4
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 70,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "填充 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "变换"
                                }
                            ],
                            "nm": "形状 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "变换"
                        }
                    ],
                    "nm": "形状 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 750,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}